module.exports = __webpack_public_path__ + "static/media/pallet-supply-image.825f08f0.webp";